<!-- <form [formGroup]="form"> -->
<div class="pb-[40px]">
  <div class="flex justify-between items-center mr-[50px] mb-[9px] mt-[20px]">
    <p class="!ml-14 !font-semibold !text-[20px]">
      {{ projectName }} - {{ labels.title }}
    </p>
    <div class="flex items-center space-x-4">
      <div class="container-fluid  !pr-[0px] bg-[#ffffff]">
        <div class="flex justify-end">
          <div
            class="rounded relative w-[fit-content]"
            (mouseenter)="tooltipVisibilityToggle()"
            (mouseleave)="tooltipVisibilityToggle()"
          >
            <button
              *ngIf="isCreator"
              class="primary-action-btn !mr-0 !text-[#ffffff] !text-[16px]"
              [ngClass]="
                submittedData?.is_initiated ||
                (!submittedData?.is_initiated && approvalsStatus !== 'approved')
                  ? '!bg-[#868E96] !border-none'
                  : ''
              "
              type="button"
              (click)="sendInvite()"
              aria-describedby="tooltip"
              [disabled]="
                submittedData?.is_initiated || approvalsStatus === 'pending'
                  ? true
                  : false
              "
            >
              {{ !submittedData?.is_initiated ? "Initiate" : "Initiated" }}
            </button>
          </div>
        </div>
        <div
        class="flex justify-end relative "
          *ngIf="showTooltip && approvalsStatus === 'pending'"
        >
          <app-custom-tooltip
            [toolTipMessage]="toolTipMessage?.INITIATE_DISABLE"
          ></app-custom-tooltip>
        </div>
      </div>
    <button (click)="handleClose()" type="button" class="close-btn">
      Close
    </button>
    <button
    *ngIf="isCreator && !submittedData?.is_initiated"
    (click)="handleEdit()"
    type="button"
    class="close-btn"
  >
    Edit
  </button>
      <button
        *ngIf="isCreator"
        type="button"
        (click)="handleClarification()"
        class="primary-action-btn "
      >
        Clarifications
      </button>
      <button
        *ngIf="isCreator"
        (click)="handleApprovals()"
[ngClass]="approvalsStatus === 'approved' ? '!bg-[#197741] !border-[#197741]' : approvalsStatus === 'approved' ? '!bg-[#ff0000] !border-[#ff0000]' : '' "
        type="button"
        class="primary-action-btn !px-[18px]"
      >
        {{ approvalResponses ? "Approval Status" : "Send For Approvals" }}
      </button>
      <button
        *ngIf="
          !isCreator &&
          !checkApprove &&
          internalApproval?.internal_approvals !== null &&
          isInApprovers
        "
        (click)="approvalResponseView(ittId, projectId)"
        type="button"
        class="primary-action-btn !px-[18px]"
      >
        Approval Requested
      </button>
      <button
        *ngIf="checkApprove && isInApprovers"
        (click)="handleApprovals()"
[ngClass]="approvalsStatus === 'approved' ? '!bg-[#197741] !border-[#197741]' : '' "
        type="button"
        class="primary-action-btn cursor-pointer !px-[18px]"
      >
        Approval Sent
      </button>
     
    </div>
  </div>

  <div
    class="header h-[55px] flex justify-start items-center mx-[50px] pl-[14px] bg-[#F1F3F5]"
  >
    <p class="!m-0">Receiver Organization Details</p>
  </div>
  <div class="mx-[50px] mt-[24px]">
    <div
      class="!mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
    >
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 table-scrolling"
      >
        <table class="!w-[100%] bg-[#fcfcfd] table-auto">
          <thead
            class="h-[52px] !bg-[#DEE2E6] text-[#000000] !text-left justify-left py-2 sticky top-0 !z-20"
          >
            <tr>
              <th class="px-4 text-left">Company</th>
              <th class="px-4 text-left">Name</th>
              <th class="px-4 text-left">Email</th>
              <th class="px-4 text-left">Position</th>
              <ng-container *ngIf="isRFPorRFQ === 'RFP'">
                <th class="px-4 text-center">Technical Score</th>
                <th class="px-4 text-center">Commercial Score</th>
              </ng-container>
              <th class="px-4 text-center">Status</th>
              <th class="px-4 text-center">Award</th>
            </tr>
          </thead>
          <tbody style="margin-right: 0px; overflow-y: auto">
            <ng-container *ngFor="let org of selectedOrgs; let i = index">
              <tr
                class="!h-[57px] hover:bg-gray-200 border-b-0 items-center justify-center"
                [ngClass]="{
                  'bg-white': i % 2 === 0,
                  'bg-[#DEE2E6]': i % 2 !== 0
                }"
              >
                <td
                  class="border-b-0 px-4 py-2 text-left cursor-pointer"
                  (click)="openIttView(org?.responseId, org?.rfp_response, org?.applicant_organization?.id)"
                  [title]="org?.applicant_organization?.email"
                >
                  {{
                    org?.applicant_organization?.name
                      ? org?.applicant_organization?.name
                      : org?.external_company_name
                  }}
                </td>
                <td class="border-b-0 px-4 py-2 text-left">{{ org?.name }}</td>
                <td class="border-b-0 px-4 py-2 text-left">{{ org?.email }}</td>
                <td class="border-b-0 px-4 py-2 text-left">
                  {{ org?.position }}
                </td>
                <ng-container *ngIf="isRFPorRFQ === 'RFP'">
                  <td class="border-b-0 px-4 py-2 text-center">
                    <!-- {{ org?.technicalEvaluationScore }} -->
                    {{ getScoresForRow(org?.applicant_organization?.id)().tech }}
                  </td>
                  <td class="border-b-0 px-4 py-2 text-center">
                    <!-- {{ org?.commercialEvaluationScore }} -->
                    {{ getScoresForRow(org?.applicant_organization?.id)().comm }}
                  </td>
                </ng-container>
                <td class="border-b-0 px-4 py-2 text-center">
                  <span
                    [ngClass]="{
                    'status-received':
                      org?.responseStatus === 'Received',
                    'status-pending':
                      org?.responseStatus === 'pending',
                      'status-submitted':
                      org?.responseStatus === 'submitted',

                  }"
                  >
                    {{ org?.responseStatus | titlecase }}
                  </span>
                </td>
                <td class="border-b-0 px-4 py-2 text-center">
                  <ng-container
                    *ngIf="
                      submittedData?.awarded_org_id === null && !org?.contractAwarded;
                      else contractAwardedTemplate
                    "
                  >
                    <button
                      class="px-4 !py-[1px] rounded-full status-pending text-yellow-600 border border-yellow-600 bg-yellow-50 hover:bg-yellow-100 cursor-pointer"
                      (click)="handleAwardContractModal(org)"
                    >
                      Pending
                    </button>
                  </ng-container>
                  <ng-template #contractAwardedTemplate>
                    {{ org?.contractAwarded ? "Awarded" : "Rejected" }}
                  </ng-template>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Receiver Side Preview</p>
    </div>
    <div class="w-[100%] !pt-[10px]">
      <p class="!ml-4 !text-[18px] !font-semibold !mb-0">Project Brief</p>
      <div class="!py-0 !pl-[2px]">
        <app-brief-section></app-brief-section>
      </div>
      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Selected Work Packages</p>
      </div>

      <div class="w-[50%] mt-[7px] ml-[12px]">
        <div
          class="w-[100%] flex justify-between items-center"
          *ngFor="let wp of selectedWp"
        >
          <div class="flex justify-start">
            <img
              src="assets/icons/checkbox.png"
              class="h-[20px] w-[20px] mr-[12px]"
              alt="checkbox"
            />
            <p class="packages-name !mb-0">{{ wp?.name }}</p>
          </div>
        </div>

        <div
          class="w-[100%] flex justify-between items-center"
          *ngIf="selectedWp.length === 0"
        >
          <p>No work package selected</p>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Request for Proposal (RFP)</p>
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 pl-[14px]"
      >
        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
          >
            Tender submission deadline
          </div>
          <div
            class="text-black font-roboto pl-5 text-[14px] font-normal leading-normal"
            [innerHTML]="
              submittedData?.submission_deadline
                ? formatDate(submittedData?.submission_deadline)
                : ''
            "
          ></div>
        </div>

        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
          >
            Submissions Address
          </div>
          <div
            class="text-black pl-5 font-roboto text-[14px] font-normal leading-normal"
          >
            {{ submittedData?.submission_address }}
          </div>
        </div>
      </div>
    </div>
    <!-- Contractual Terms -->
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Contractual Terms</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 pl-[14px]">
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Contract Type
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.contract_type_details
              ? submittedData?.contract_type_details
              : "Not Added"
          }}
        </div>
      </div>
      <div
        class="flex items-center"
        *ngIf="submittedData?.contract_type_attach"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Attachment
        </div>
        <div
          class="text-black font-roboto text-[14px] font-normal leading-normal"
        >
          <p class="bg-[#fff4f0] rounded-2xl w-[300px] text-left !pl-5">
            Contract Type Doc.pdf
          </p>
        </div>
      </div>
    </div>
    <!-- Key Date -->
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Key Dates</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 pl-[14px]">
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Issue of ITT
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.issue_date
              ? (submittedData?.issue_date | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Clarification Deadline
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.clarification_deadline
              ? (submittedData?.clarification_deadline | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Contract Award Notification
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.contract_award_notification
              ? (submittedData?.contract_award_notification
                | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto !text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Contract Start Date
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.contract_start_date
              ? (submittedData?.contract_start_date | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto !text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Project Completion Date
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.project_completion_date
              ? (submittedData?.project_completion_date | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
    </div>
    <!-- Toggle Button -->
    <div
    class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0 !pr-[30px]">RFP forms and Templates</p>
    <button (click)="toggle()" 
    class="flex items-center justify-center toggleButton p-2">
    
    <div class="w-12 h-6 pr-[5px] bg-gray-300 rounded-full relative toggle-button"
         [class.active]="showTemplateForm">
         
        <div class="w-6 h-6 bg-white rounded-full absolute transition-all duration-300"
             [class.translate-x-6]="showTemplateForm">
        </div>
    </div>
</button>

  </div>
    <!-- ITT forms and Templates -->
    <div class="pl-[14px]" *ngIf="showTemplateForm">
      <app-itt-applicant-read-only-form
        [isShowRfpSubmitBtn]="false"
      ></app-itt-applicant-read-only-form>
    </div>
  </div>
</div>
<!-- </form> -->

<ng-container *ngIf="isEdit">
  <app-wrapper
    (handleDialog)="handleDialog()"
    [currentDialog]="currentDialog"
    [isEdit]="isEdit"
  ></app-wrapper>
</ng-container>
